const SUBCATEGORIES = "subCategories";
const OPTIONS = "Opciones";

const shouldRenderButton = (currentDisplayedForm, level, formLevel) => {
	const belongsToParent = currentDisplayedForm.level === formLevel.level;
	const belongsToSameSubLevel = formLevel.subLevel === currentDisplayedForm.subLevel;
	const isSameLevel = currentDisplayedForm.level === level.level;
	const isSameSubLevel = currentDisplayedForm.subLevel === level.subLevel;
	const isSameFormSubLevel = currentDisplayedForm.subLevel === formLevel.subLevel;
	const isParentLevel = formLevel.level === 0;
	const isSecondLevel = currentDisplayedForm.level === 2;
	const isFirstLevelOrLess = currentDisplayedForm.level < 2;
	const isSameOption = currentDisplayedForm?.position?.Opciones === level?.position?.Opciones;
	const isSameSubCategory = currentDisplayedForm?.position?.subCategories === level?.position?.subCategories;

	if (belongsToParent && belongsToSameSubLevel && isFirstLevelOrLess) {
		return true;
	}

	if (isSameLevel && isSameSubLevel && (isSameFormSubLevel || isParentLevel) && isFirstLevelOrLess) {
		return true;
	}

	if (isSecondLevel && isSameOption && isSameSubCategory) {
		return true;
	}
	return false;
};

const shouldRenderInput = (currentDisplayedForm, level, formLevel) => {
	const isSameLevel = currentDisplayedForm.level === level.level;
	const isSameSubLevel = currentDisplayedForm.subLevel === level.subLevel;
	const hasPropertyOptions = currentDisplayedForm?.position?.hasOwnProperty(OPTIONS);
	const isSecondLevel = currentDisplayedForm.level === 2;

	if ((isSameLevel && isSameSubLevel) || (isSecondLevel && hasPropertyOptions)) {
		return true;
	}

	return false;
};

const params = (name, i, id) => ({
	variant: "caption",
	label: name || `${id} ${i + 1}`,
	i,
});

export { shouldRenderButton, shouldRenderInput, params, SUBCATEGORIES, OPTIONS };
